export enum TokenRestorationType {
	ADDITIONAL_USER = 'ADDITIONAL_USER',
	RESTORE_PASS  = 'RESTORE_PASS',
	EMAIL_VERIFICATION = 'EMAIL_VERIFICATION'
}
